var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTiktokBlack = function SvgTiktokBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.514 16.4c1.65 0 2.99-1.183 2.99-2.99V0h3.585c-.201 2.446 2.23 4.808 4.911 4.754v3.371c-2.293 0-4.243-.97-4.921-1.507v6.791c0 2.99-2.352 6.38-6.565 6.38C2.3 19.79 0 16.4 0 13.41c0-4.22 4.466-6.667 7.423-6.068v3.434a3.142 3.142 0 0 0-.86-.13c-1.664-.062-3.039 1.288-3.039 2.764a2.99 2.99 0 0 0 2.99 2.99Z",
    fill: "#000"
  })));
};

export default SvgTiktokBlack;